import { EntityChildEditModal } from '@/pages/admin/shared/entity-management/EntityChildEditModal';

type EditSubcategoryModalProps = {
	isOpen: boolean;
	onClose: () => void;
	categoryName: string;
	initialSubcategoryName: string;
	onSave: (name: string) => void;
};

export const EditSubcategoryModal = ({
	isOpen,
	onClose,
	categoryName,
	initialSubcategoryName,
	onSave,
}: EditSubcategoryModalProps) => {
	return (
		<EntityChildEditModal
			isOpen={isOpen}
			onClose={onClose}
			title="Editar subcategoria"
			description="Altere o nome da subcategoria vinculada à categoria."
			parentLabel="CATEGORIA"
			parentName={categoryName}
			childLabel="NOME DA SUBCATEGORIA"
			childPlaceholder="Ex: Saúde mental"
			submitText="Salvar alterações"
			inputId="form-edit-modal-subcat-name"
			initialChildName={initialSubcategoryName}
			onSave={onSave}
		/>
	);
};
